import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { BalanceSheetRoutingModule } from './balance-sheet-routing.module';
import { BalanceSheetListComponent } from './balance-sheet-list/balance-sheet-list.component';
import { BalanceSheetCreateComponent } from './balance-sheet-create/balance-sheet-create.component';

@NgModule({
  declarations: [BalanceSheetListComponent, BalanceSheetCreateComponent],
  imports: [
    CommonModule,
    BalanceSheetRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class BalanceSheetModule { }
